import type { ExpenseWithGroup } from '@/api/expenses';
import { fromMinorUnits, getMinorUnitsSync } from '@sharecost/shared';

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function exportExpensesToCsv(expenses: ExpenseWithGroup[]): void {
  const headers = ['Description', 'Group', 'Paid By', 'Category', 'Amount', 'Currency', 'Date'];

  const rows = expenses.map(e => {
    const minorUnits = getMinorUnitsSync(e.currency_code_src);
    const amount = fromMinorUnits(Number(e.amount_minor_src), minorUnits);
    return [
      escapeCsvField(e.description),
      escapeCsvField(e.group?.name ?? ''),
      escapeCsvField(e.paid_by_user?.display_name ?? 'Unknown'),
      escapeCsvField(e.category?.name ?? 'Uncategorized'),
      amount.toString(),
      e.currency_code_src,
      e.expense_date?.split('T')[0] ?? '',
    ].join(',');
  });

  const csv = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `sharecost-expenses-${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
